function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M62.131 15.253v58.436c0 1.574-1.244 2.85-2.778 2.85H3.779C2.244 76.54 1 75.264 1 73.69V3.851C1 2.276 2.244 1 3.779 1h44.459",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.131 15.253v58.436c0 1.574-1.244 2.85-2.778 2.85H3.779C2.244 76.54 1 75.264 1 73.69V3.851C1 2.276 2.244 1 3.779 1h44.459",
  stroke: "#E5E5E5",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M62.132 15.253H49.658a1.42 1.42 0 01-1.42-1.42V1",
  fill: "#D8D8D8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M62.132 15.253H49.658a1.42 1.42 0 01-1.42-1.42V1",
  fill: "#E5E5E5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.236 14.947h17.051",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.906 10.366H24.75",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeDasharray: "4.06 4.06"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10.236 19.529h24.562",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M10.236 24.11h4.466",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M17.544 24.11h10.86",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.063 28.691h9.946",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M24.851 28.691h1.726",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M12.063 33.272h8.12",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M23.024 33.272h19.081",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M12.063 37.853h4.06",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M19.269 37.853h14.615",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M13.89 42.435h13.397",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M30.23 42.435h6.395",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M15.716 47.016h6.293",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M24.75 47.016h1.827",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M10.236 51.597h4.466",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M17.544 51.597h10.86",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M12.063 56.178h9.946",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M24.851 56.178h1.726",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M12.063 60.76h8.12",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M23.024 60.76h19.081",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M12.063 65.341h4.06",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M19.269 65.341h14.615",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M72.883 19.713V78.15c0 1.575-1.244 2.851-2.779 2.851H14.53c-1.534 0-2.778-1.276-2.778-2.85V8.31c0-1.573 1.243-2.85 2.778-2.85h44.46",
  fill: "#fff"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M72.883 19.713V78.15c0 1.575-1.244 2.851-2.779 2.851H14.53c-1.534 0-2.778-1.276-2.778-2.85V8.31c0-1.573 1.243-2.85 2.778-2.85h44.46",
  stroke: "#D8D8D8",
  strokeWidth: 2
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M72.883 19.713H60.41a1.42 1.42 0 01-1.42-1.42V5.46",
  fill: "#D8D8D8"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M72.883 19.713H60.41a1.42 1.42 0 01-1.42-1.42V5.46",
  fill: "#C5C5C5"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M20.987 19.408h17.051",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M20.658 14.826H35.5",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeDasharray: "4.06 4.06"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M20.987 23.989H45.55",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M20.987 28.57h4.466",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M28.295 28.57h10.86",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M22.815 33.151h9.946",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M35.603 33.151h1.725",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M22.815 37.733h8.12",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M33.776 37.733h19.08",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M22.815 42.314h4.06",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M30.021 42.314h14.615",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M24.641 46.895h13.397",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M40.982 46.895h6.394",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M26.468 51.477h6.293",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M35.502 51.477h1.826",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M20.987 56.058h4.466",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M28.295 56.058h10.86",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M22.815 60.639h9.946",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M35.603 60.639h1.725",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M22.815 65.22h8.12",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M33.776 65.22h19.08",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M22.815 69.801h4.06",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M30.021 69.801h14.615",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref55 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#collect_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M67.844 30.058c5.807 0 10.515-4.704 10.515-10.506 0-5.802-4.708-10.505-10.515-10.505S57.329 13.75 57.329 19.552c0 5.802 4.708 10.506 10.515 10.506z",
  fill: "#fff"
}));

var _ref56 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72.927 16.111a.905.905 0 00-.448-.517l-4.268-2.042a.784.784 0 00-.35-.07c-.112 0-.238 0-.35.028l-4.269 2.056a.752.752 0 00-.42.518l-1.05 4.6a.882.882 0 00.154.672l2.954 3.65c.168.168.406.28.643.294h4.703a.698.698 0 00.644-.294l2.953-3.65a.954.954 0 00.168-.671l-1.064-4.573z",
  fill: "#326DE6"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72.27 20.503c-.015 0-.029 0-.029-.014s-.028-.014-.055-.014c-.057-.014-.113-.014-.169-.014-.027 0-.055 0-.084-.014h-.014a2.827 2.827 0 01-.475-.084.169.169 0 01-.098-.098l-.112-.028a3.644 3.644 0 00-.056-1.23 3.788 3.788 0 00-.49-1.147l.084-.084v-.014c0-.042.014-.098.042-.126a2.51 2.51 0 01.392-.28l.084-.042c.028-.014.052-.028.077-.042a1.53 1.53 0 01.077-.042c.007-.007.014-.01.02-.014a.073.073 0 00.022-.014c.008-.008.006-.012.003-.016a.02.02 0 01-.003-.012c.126-.098.154-.265.056-.391a.267.267 0 00-.196-.098c-.07 0-.14.028-.196.07l-.014.014c-.014.014-.028.028-.042.028a.905.905 0 00-.112.126c-.01.02-.026.032-.04.043-.006.004-.012.008-.016.013a1.838 1.838 0 01-.35.307c-.028.014-.056.028-.084.028-.014 0-.042 0-.056-.014h-.014l-.112.07c-.056-.056-.115-.112-.175-.168a7.848 7.848 0 01-.175-.168 3.588 3.588 0 00-1.82-.727l-.013-.112v.014c-.042-.028-.056-.07-.07-.111 0-.154 0-.308.028-.476v-.014c0-.014.003-.028.007-.042.003-.014.007-.028.007-.042a.7.7 0 00.014-.084c.003-.028.007-.056.014-.084v-.084a.277.277 0 00-.238-.293c-.084-.014-.168.028-.238.098a.276.276 0 00-.084.195v.07c0 .056.014.112.028.168.014.028.014.056.014.084v.014c.028.154.028.308.028.476-.014.041-.028.083-.07.111v.028l-.014.112a5.37 5.37 0 00-.404.058l-.072.012c-.658.14-1.26.49-1.722.98l-.084-.057h-.014c-.005 0-.011.003-.018.005a.091.091 0 01-.038.01.199.199 0 01-.084-.029 2.585 2.585 0 01-.35-.321.128.128 0 00-.04-.043.904.904 0 01-.072-.076.905.905 0 00-.055-.063c-.007-.007-.014-.01-.021-.014-.007-.004-.014-.007-.021-.014l-.014-.014a.334.334 0 00-.196-.07c-.084 0-.154.028-.196.098a.3.3 0 00.056.391c.014 0 .014.014.014.014s.028.028.042.028c.042.028.098.056.154.084l.084.042c.14.084.28.168.392.28.025.025.05.074.044.114l-.003-.002v.014a.061.061 0 00.003-.012l.081.082-.02.035a3.319 3.319 0 00-.51 2.329l-.113.027c0 .014-.014.014-.014.014-.014.042-.056.07-.098.098a2.59 2.59 0 01-.476.084c-.028 0-.056 0-.084.014a.68.68 0 00-.084.007c-.028.003-.056.007-.084.007-.006 0-.012.002-.019.005a.091.091 0 01-.037.009l-.013.001c-.004.001-.007.005-.015.013a.273.273 0 00-.224.322.26.26 0 00.28.195c.028 0 .042 0 .07-.014.014 0 .014 0 .014-.014 0-.01.02-.005.037-.002l.019.002a.781.781 0 00.102-.036.845.845 0 01.052-.02.198.198 0 01.084-.027h.014c.154-.056.294-.098.462-.126h.014a.16.16 0 01.112.042c.014 0 .014.014.014.014l.126-.014c.21.643.601 1.216 1.147 1.636.126.098.238.182.378.252l-.07.097c0 .014.014.014.014.014a.165.165 0 01.014.14c-.056.14-.14.28-.224.406v.014a.246.246 0 01-.056.07c-.016.016-.031.04-.05.068a1.132 1.132 0 01-.062.093c-.003.007-.007.014-.014.02 0 0 0 .015-.014.015a.288.288 0 00.112.377c.028.014.07.028.098.028.112 0 .21-.07.266-.168 0 0 0-.014.014-.014 0-.014.014-.028.028-.042a.495.495 0 01.028-.076.495.495 0 00.028-.078l.028-.083c.042-.154.112-.294.182-.434a.218.218 0 01.112-.084c.014 0 .014 0 .014-.014l.056-.112c.392.154.798.224 1.218.224.252 0 .504-.028.755-.098.115-.02.23-.057.339-.092l.11-.034.055.098c.007 0 .01 0 .013.002l.001.012a.218.218 0 01.112.084c.07.14.14.28.182.434v.014l.028.084a.5.5 0 00.056.153c.007.007.01.014.014.021.004.007.007.014.014.021 0 0 0 .014.014.014a.314.314 0 00.266.168.24.24 0 00.087-.02.972.972 0 01.025-.008.234.234 0 00.126-.154.36.36 0 00-.014-.21c0-.013-.014-.013-.014-.013 0-.014-.014-.028-.028-.042a.502.502 0 00-.098-.14.246.246 0 00-.056-.07v-.028a1.65 1.65 0 01-.224-.406.165.165 0 01.014-.14c0-.014.014-.014.014-.014l-.042-.111a3.457 3.457 0 001.512-1.902l.112.014c.014 0 .014-.014.014-.014a.159.159 0 01.112-.042h.014c.154.028.308.07.448.125h.014a.198.198 0 00.084.029l.04.02c.038.02.072.039.114.05.005 0 .011.002.018.005.01.004.021.008.038.008.013 0 .013 0 .027.014a.126.126 0 00.07.014.304.304 0 00.28-.195.33.33 0 00-.252-.294zm-4.045-.434l-.378.182-.378-.182-.098-.405.266-.336h.42l.265.336-.097.405zm2.337-.028a2.675 2.675 0 00-.056-.88 2.845 2.845 0 00-.336-.826l-1.05.951a.226.226 0 00-.056.098c-.027.126.043.252.169.28l1.33.377zm-.812-2.223l-1.148.81c-.098.057-.238.043-.308-.055a.127.127 0 01-.042-.098l-.084-1.413c.616.07 1.162.336 1.582.756zm-2.253-.77l-.28.057a2.78 2.78 0 00-1.302.713l1.162.825a.842.842 0 01.025.008c.03.011.054.02.087.02.126 0 .238-.098.238-.224l.07-1.398zm-1.988 1.287l1.036.923a.225.225 0 01.028.322c-.028.042-.056.056-.112.07l-1.358.391a2.943 2.943 0 01.406-1.706zm1.148 2.126l-1.386.238c.196.56.588 1.049 1.078 1.37l.532-1.286a.165.165 0 00.014-.14c-.014-.112-.126-.182-.238-.182zm1.792 1.972c-.196.042-.392.07-.602.07a3.14 3.14 0 01-.882-.14l.686-1.245a.217.217 0 01.28-.056c.042.028.07.056.112.098l.672 1.217a2.294 2.294 0 00-.266.056zm.868-.378c.335-.21.63-.503.84-.839a2.1 2.1 0 00.265-.531l-1.4-.238c-.041 0-.083.014-.125.028a.227.227 0 00-.126.266l.546 1.314z",
  fill: "#fff"
});

var _ref58 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#collect_svg__filter1_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M67.844 54.199c5.807 0 10.515-4.704 10.515-10.506 0-5.802-4.708-10.505-10.515-10.505s-10.515 4.703-10.515 10.505c0 5.802 4.708 10.506 10.515 10.506z",
  fill: "#fff"
}));

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M67.675 37.786c-3.151 0-5.695.906-5.748 2.038v.035c0 .131.08.3.337.507.258.208.675.422 1.201.6 1.053.358 2.55.59 4.21.59 1.66 0 3.157-.232 4.21-.59.526-.178.943-.392 1.201-.6.258-.208.337-.376.337-.507v-.023c-.035-1.138-2.586-2.05-5.748-2.05zm-5.748 3.257v2.774c0 .13.08.299.337.506.258.208.675.422 1.201.601 1.053.357 2.55.589 4.21.589 1.66 0 3.157-.232 4.21-.589.526-.179.943-.393 1.201-.6.258-.208.337-.376.337-.507v-2.774c-.346.254-.788.464-1.314.642-1.155.392-2.711.624-4.434.624-1.723 0-3.28-.232-4.434-.624-.526-.178-.968-.388-1.314-.642zm0 3.958v2.585c0 .13.08.299.337.507.258.207.675.421 1.201.6 1.053.358 2.55.59 4.21.59 1.66 0 3.157-.233 4.21-.59.526-.178.943-.393 1.201-.6.258-.208.337-.376.337-.507v-2.585c-.346.253-.788.463-1.314.642-1.155.392-2.711.624-4.434.624-1.723 0-3.28-.232-4.434-.625-.526-.178-.968-.388-1.314-.641z",
  fill: "#4B6"
});

var _ref60 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#collect_svg__filter2_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M67.844 78.34c5.807 0 10.515-4.704 10.515-10.506 0-5.802-4.708-10.505-10.515-10.505s-10.515 4.703-10.515 10.505c0 5.802 4.708 10.506 10.515 10.506z",
  fill: "#fff"
}));

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M66.675 63.046a18.784 18.784 0 00-.887-.8 5.75 5.75 0 015.008.602 9.567 9.567 0 00-2.63.433 1.043 1.043 0 00-1.49-.235zm-1.472 4.096a8.117 8.117 0 002.515 1.638 6.77 6.77 0 002.085.475 1.03 1.03 0 01.317-.562 16.021 16.021 0 00-2.382-3.847c-.421.193-.92.082-1.22-.27a6.57 6.57 0 00-.626.48 6.773 6.773 0 00-.82.857c.31.334.363.832.13 1.224v.005zm6.185-3.848a9.568 9.568 0 00-3.049.408c.062.316-.03.643-.248.88a16.503 16.503 0 012.411 3.884 1.051 1.051 0 011.027.22c.61-.365 1.243-.69 1.894-.976v-.025a5.734 5.734 0 00-2.033-4.4l-.002.01zm-1.268 6.944c-1.48 1.254-2.145 2.473-2.43 3.185a5.727 5.727 0 003.431-1.138 13.355 13.355 0 00-.362-1.774 1.04 1.04 0 01-.637-.28l-.002.007zm-.166-.378a1.696 1.696 0 00-.098-.166 7.384 7.384 0 01-2.277-.512 8.674 8.674 0 01-2.663-1.715 1.02 1.02 0 01-.877.152 10.946 10.946 0 00-.915 3.572 5.84 5.84 0 004.141 2.214c.275-.764.867-2.141 2.689-3.545zm1.87-.744c.04.11.058.225.058.342v.1c-.04.4-.305.743-.683.882.135.498.242 1.002.32 1.511A5.732 5.732 0 0073.4 68.2c-.55.25-1.085.53-1.603.841a.8.8 0 01.028.075zm-8.581-2.502c0-.259.097-.508.27-.699-.28-.378-.538-.771-.774-1.178a5.746 5.746 0 000 5.89c.132-1.109.432-2.191.89-3.21a1.044 1.044 0 01-.386-.812v.009zm.635-.965c.265-.115.566-.115.83 0a7.054 7.054 0 011.594-1.467.986.986 0 01.084-.794c-.407-.394-.774-.71-1.067-.951a5.772 5.772 0 00-2.304 1.877c.26.456.548.895.863 1.315v.02z",
  fill: "#A048F8"
});

var _ref62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "collect_svg__filter0_d",
  x: 53.329,
  y: 5.047,
  width: 29.03,
  height: 29.011,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "collect_svg__filter1_d",
  x: 53.329,
  y: 29.188,
  width: 29.03,
  height: 29.011,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "collect_svg__filter2_d",
  x: 53.329,
  y: 53.329,
  width: 29.03,
  height: 29.011,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgCollect = function SvgCollect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62);
};

export default __webpack_public_path__ + "static/collect.1d327795.svg";
export { SvgCollect as ReactComponent };